// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__16l7P","footer":"ReportModalFilter_footer__EDGX7"};